import { distributionBidPaymentTypesEnum } from "helpers/enums";
import { applyBidPayment } from "sources/books/bids/closeBids";
import { applyPayment as applyDistributionBidPayment } from "sources/books/distributionBids";

export const applyReportPayment = (row, payment, isAccountsPayable) => {
    if (row.isDistributionBid) {
        return applyDistributionBidPayment({
            distributionBidId: row.bidId,
            paymentType: isAccountsPayable
                ? distributionBidPaymentTypesEnum.HiredCar
                : distributionBidPaymentTypesEnum.Customer,
            payment,
        });
    }
    return applyBidPayment({ bidId: row.bidId, payment });
};
